import { NovoAtendimentoFormModel } from './model'

const agendamentoSelecionadoMessage = 'Campos não podem ser editados pois há um agendamento selecionado'

export const resolveEquipeTooltip = (values: NovoAtendimentoFormModel): string => {
  if (values?.agendados?.length) {
    return agendamentoSelecionadoMessage
  }

  if (!!values?.lotacao) {
    if (!!values?.equipe) {
      return 'Equipe do profissional responsável selecionado'
    } else {
      return 'Profissional responsável sem equipe associada'
    }
  }
}

export const resolveProfissionalTooltip = (values: NovoAtendimentoFormModel): string => {
  if (values?.agendados?.length) {
    return agendamentoSelecionadoMessage
  }
  if (!!values?.equipe && !values?.lotacao) {
    return 'Equipe responsável selecionada'
  }
}

export const resolveTiposServicoTooltip = (values: NovoAtendimentoFormModel): string =>
  !!values?.agendados?.length && agendamentoSelecionadoMessage
